import { render, staticRenderFns } from "./course-editor.vue?vue&type=template&id=551b684a&"
import script from "./course-editor.vue?vue&type=script&lang=js&"
export * from "./course-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports